import { Column } from "components/flexComponents/MultiColumnContainer/model/Column";
import { TwoColumn } from "components/flexComponents/MultiColumnContainer/decorators/TwoColumn/TwoColumn";

/**
 * Constructs a two column starting from the left as such:
 *
 * ------------
 * | 1     3  |
 * |          |
 * | 2     4  |
 * ------------
 *
 * If 1 and 2 is missing:
 * ------------
 * | 3     4  |
 * |          |
 * |          |
 * ------------
 *
 */
export class EqualTwoColumn extends TwoColumn {
  public constructor(column: Column) {
    super(column) /* istanbul ignore next */;

    const middleModuleIndex = Math.ceil(this.wrappedColumn.modules.length / 2);
    this.setLeftAndRightColumn(
      this.wrappedColumn.modules.slice(0, middleModuleIndex),
      this.wrappedColumn.modules.slice(middleModuleIndex)
    );
  }
}
